// src/components/panoramica/RulesPanel.js
// Regolamento della lega: le voci che cambiano davvero la scelta della
// formazione (modificatore di difesa → difesa a 4, capitano/vice, valori dei
// bonus/malus). Salvato sull'asta, come prima.
import React, { useState } from 'react';
import { SlidersHorizontal, ChevronDown } from 'lucide-react';

function Toggle({ checked, onChange, label, hint }) {
  return (
    <label className="pz-toggle">
      <span className="pz-switch">
        <input type="checkbox" checked={Boolean(checked)} onChange={(e) => onChange(e.target.checked)} />
        <span className="pz-switch__track" />
        <span className="pz-switch__thumb" />
      </span>
      <span className="pz-toggle__text"><strong>{label}</strong>{hint && <em>{hint}</em>}</span>
    </label>
  );
}

function NumberField({ label, value, step = 0.5, min = -10, max = 20, onChange }) {
  return (
    <label className="pz-num">
      <span>{label}</span>
      <input
        type="number"
        inputMode="decimal"
        step={step}
        min={min}
        max={max}
        value={value}
        onChange={(e) => onChange(e.target.value === '' ? '' : Number(e.target.value))}
      />
    </label>
  );
}

export default function RulesPanel({ rules, onChange }) {
  const [open, setOpen] = useState(false);
  const set = (key) => (val) => onChange({ ...rules, [key]: val });
  const setBand = (i, field) => (val) => {
    const bands = rules.defModBands.map((b, j) => (j === i ? { ...b, [field]: val } : b));
    onChange({ ...rules, defModBands: bands });
  };
  const chips = [
    rules.defenseModifier && 'Mod. difesa',
    rules.captain && (rules.viceCaptain ? 'Capitano + vice' : 'Capitano'),
    rules.cleanSheet && 'Imbattibilità',
    `Gol +${rules.goalBonus}`,
    `Assist +${rules.assistBonus}`,
  ].filter(Boolean);

  return (
    <section className="pz-card pz-rules" id="pz-regole">
      <button type="button" className="pz-rules__head" onClick={() => setOpen((o) => !o)} aria-expanded={open}>
        <span className="pz-rules__icon"><SlidersHorizontal size={16} /></span>
        <span className="pz-rules__title">
          <strong>Regolamento della tua lega</strong>
          <em>Cambia la formazione consigliata: es. col modificatore di difesa conviene la difesa a 4.</em>
        </span>
        <span className="pz-rules__chips">
          {chips.map((c) => <span key={c} className="pz-chip">{c}</span>)}
        </span>
        <ChevronDown size={16} className={`pz-rules__chev ${open ? 'is-open' : ''}`} />
      </button>

      {open && (
        <div className="pz-rules__body">
          <div className="pz-rules__group">
            <h4>Modificatore di difesa</h4>
            <Toggle
              checked={rules.defenseModifier}
              onChange={set('defenseModifier')}
              label="Attivo"
              hint="Media voto di portiere + 3 migliori difensori; vale solo con almeno 4 difensori."
            />
            {rules.defenseModifier && (
              <div className="pz-bands">
                {rules.defModBands.map((b, i) => (
                  <div key={i} className="pz-band">
                    <NumberField label="Media da" value={b.min} step={0.25} min={4} max={9} onChange={setBand(i, 'min')} />
                    <NumberField label="Bonus" value={b.bonus} step={0.5} min={0} max={10} onChange={setBand(i, 'bonus')} />
                  </div>
                ))}
              </div>
            )}
          </div>

          <div className="pz-rules__group">
            <h4>Capitano</h4>
            <Toggle checked={rules.captain} onChange={set('captain')} label="Regola capitano" hint="Il fantavoto sopra il 6 del capitano conta doppio." />
            <Toggle
              checked={rules.viceCaptain}
              onChange={set('viceCaptain')}
              label="Vice-capitano"
              hint="Prende il posto del capitano se questi non gioca."
            />
          </div>

          <div className="pz-rules__group">
            <h4>Portiere</h4>
            <Toggle checked={rules.cleanSheet} onChange={set('cleanSheet')} label="Imbattibilità" hint="Bonus se non subisce gol." />
            <div className="pz-nums">
              {rules.cleanSheet && <NumberField label="Bonus imbattibilità" value={rules.cleanSheetBonus} onChange={set('cleanSheetBonus')} />}
              <NumberField label="Malus gol subito" value={rules.goalConcededMalus} onChange={set('goalConcededMalus')} />
            </div>
          </div>

          <div className="pz-rules__group">
            <h4>Bonus e malus</h4>
            <div className="pz-nums">
              <NumberField label="Gol" value={rules.goalBonus} onChange={set('goalBonus')} />
              <NumberField label="Assist" value={rules.assistBonus} onChange={set('assistBonus')} />
              <NumberField label="Ammonizione" value={rules.yellowMalus} onChange={set('yellowMalus')} />
              <NumberField label="Espulsione" value={rules.redMalus} onChange={set('redMalus')} />
              <NumberField label="Autogol" value={rules.ownGoalMalus} onChange={set('ownGoalMalus')} />
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
